import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    container: {
        textAlign: 'center',
        padding: '20px 0',
        backgroundColor: props => props.backgroundColor,
        height: props => props.height,
    },
    text:{
        padding: '40px', 
        color: 'white',
    }
}))

const Divider = ({ text, children, ...props }) => {
    const classes = useStyles(props)
    return (
        <div className="parallax" className={classes.container}>
            {text ?
                <Typography ariant="subtitle1" align='center' className={classes.text}>
                    {text}
                </Typography> :
                ''}
            {children}
        </div>
    )
}

export default Divider;